import { render } from "./insurance-order.vue?vue&type=template&id=08023dd8&scoped=true&ts=true"
import script from "./insurance-order.vue?vue&type=script&lang=ts"
export * from "./insurance-order.vue?vue&type=script&lang=ts"

import "./insurance-order.vue?vue&type=style&index=0&id=08023dd8&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08023dd8"]])

export default __exports__